import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import { thirdPartyFetchersMap } from '../../../../shared/fetchers';
import { LabeledToggle } from '../../generic/Forms/LabeledToggle';
import { icons, IconText } from '../../generic/Icon';
import Section from '../../shared/settings/SettingsPageSection';
import type { ThirdPartyFetcher } from '../../../../shared/fetchers';

import styles from './RiskRuleComponent.module.less';

type Props = {
  title: string;
  description: string;
  supportedFetchers?: ThirdPartyFetcher[];
  isEnabled: boolean;
  onToggle: (isChecked: boolean) => void;
};

const RiskRuleComponent: VoidFunctionComponent<Props> = ({
  title,
  description,
  supportedFetchers,
  isEnabled,
  onToggle,
}) => {
  const supportedEcosystemsText = useMemo(() => {
    if (!supportedFetchers || supportedFetchers.length === 0) {
      return null;
    }
    const ecosystemListStr = supportedFetchers.map((fetcher) => thirdPartyFetchersMap[fetcher]).sort().join(', ');
    return `This feature is supported for ${ecosystemListStr} projects.`;
  }, [supportedFetchers]);

  return (
    <div className={styles.container}>
      <LabeledToggle
        label={title}
        isChecked={isEnabled}
        onChange={(isChecked) => onToggle(isChecked)}
      />
      <Section.Paragraph>{description}</Section.Paragraph>
      {supportedEcosystemsText && (
        <div className={styles.severity}>
          <IconText icon={icons.infoCircle} text={supportedEcosystemsText} />
        </div>
      )}
    </div>
  );
};

export default RiskRuleComponent;
